export interface FieldSpacerProps {
  width?: number;
}

export const FIELD_SPACER_HEIGHT_PX = 16;
